"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLLOWING_ROW_SELECTOR = exports.FOLLOWING_COUNTER_SELECTOR = exports.FOLLOWERS_COUNTER_SELECTOR = void 0;

/** Profile sidebar counter showing the visited user's follower count. */
var FOLLOWERS_COUNTER_SELECTOR = '.js-followers';
/** Profile sidebar counter showing the visited user's following count. */

exports.FOLLOWERS_COUNTER_SELECTOR = FOLLOWERS_COUNTER_SELECTOR;
var FOLLOWING_COUNTER_SELECTOR = '.js-following';
/** Row wrapper around a single user entry on the Following tab. */

exports.FOLLOWING_COUNTER_SELECTOR = FOLLOWING_COUNTER_SELECTOR;
var FOLLOWING_ROW_SELECTOR = '.js-favorite';
exports.FOLLOWING_ROW_SELECTOR = FOLLOWING_ROW_SELECTOR;